<div fxLayout="column" fxFlex="100">
    <div fxLayout="row" class="wizard-row">
        <h3>1. Συνδεθείτε με το Microsoft Office 365 email σας</h3>
    </div>

    <div *ngIf="loginDisplay">
        Είστε συνδεδεμένοι με το λογαριασμό <b><u>{{studentFormGroup.controls.studentEmail.value}}</u></b>
    </div>

    <!--#region Sign In/Out From Office365-->
    <div fxLayout="row" class="wizard-row">
        <button *ngIf="!loginDisplay"  mat-raised-button color="primary" (click)="onLogin()"
                [class.spinner]="isLoading" [disabled]="isLoading" style="width: 50%;">
            <span>Είσοδος</span>
        </button>

        <button *ngIf="loginDisplay" mat-raised-button color="primary" (click)="onLogout()"
                [class.spinner]="isLoading" [disabled]="isLoading" style="width: 50%;">
            <span>Έξοδος</span>
        </button>
    </div>
    <!--#endregion-->

    <div *ngIf="loginDisplay" fxLayout="row" class="wizard-row">
        <h3>2. Επιβεβαιώστε ότι τα στοιχεία σας είναι σωστά</h3>
    </div>

    <div *ngIf="loginDisplay" fxLayout="row" fxFlex="100" fxLayoutAlign="space-evenly" fxLayoutGap="5px">

        <div fxLayout="column" fxFlex="48">
            <mat-form-field appearance="legacy">
                <mat-label>Όνομα</mat-label>
                <input matInput [value]="student.firstName" readonly>
            </mat-form-field>

            <mat-form-field appearance="legacy">
                <mat-label>Ημ. Γέννησης</mat-label>
                <input matInput [value]="student.birthday" readonly>
            </mat-form-field>
        </div>

        <div fxLayout="column" fxFlex="48">
            <mat-form-field appearance="legacy">
                <mat-label>Επώνυμο</mat-label>
                <input matInput [value]="student.lastName" readonly>
            </mat-form-field>

            <mat-form-field appearance="legacy">
                <mat-label>Email</mat-label>
                <input matInput [value]="student.email" readonly>
            </mat-form-field>
        </div>

    </div>
</div>
